import { createFileRoute } from "@tanstack/react-router";
import SEOAudit from "@/pages/SEOAudit";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/seo-audit/")({
  head: () => routeHead("/seo-audit/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SEOAudit />
  );
}
